<template>
  <vue-scroll>
    <el-row :gutter="20">
      <template>
        <div>
          <el-col :span="8" :offset="10">
            <el-tag style="font-size: 18px">Planificacion</el-tag>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-tag type="success" style="font-size: 18px">Ejecutados</el-tag>
          </el-col>
        </div>
      </template>
    </el-row>

    <RabbeyTable3
      :columns="columns"
      :data="Itmes"
      :actions="actionsNew"
      @rtable-push-action="handlePushAction"
    />
    <el-dialog
      :visible.sync="modalVisible"
      title="Agregar Comentario al Projecto"
      :width="dialogWidth"
      @close="closeModal"
    >
      <div class="block">
        <el-form
          ref="ruleForm"
          label-width="120px"
          style="margin-top: 5%"
          class="demo-ruleForm"
        >
          <el-form-item label="Comentario" prop="desc">
            <!-- <el-input v-model="Comment" ></el-input> -->
            <el-input type="textarea" v-model="Comment"></el-input>

            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              style="margin-left: 80%; margin-top: 5%"
              >Enviar</el-button
            >
          </el-form-item>

          <el-form-item> </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-drawer
      :title="titulo"
      :visible="openDetail"
      size="60%"
      :before-close="CloseTransactionDetail"
    >
      <el-row :gutter="20">
        <el-col :span="6" :offset="6"
          ><div class="grid-content bg-purple"></div
        ></el-col>
        <el-col :span="6" :offset="18"> </el-col>
      </el-row>

      <RabbeyTable3
        :columns="columnsdetails"
        :data="Itmesdetails"
        style="margin: 20px"
      />
    </el-drawer>
  </vue-scroll>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
// import RenderLabelBlue from '@/components/functionals/RenderLabel.vue'
// import RenderLabelGreen from '@/components/functionals/RenderLabelGreen.vue'
import HyperLinkReportProyects from "@/components/functionals/HyperLinkReportProyects.vue";

export default {
  name: "ProjectRport",
  components: {
    RabbeyTable3
  },
  data() {
    return {
      Itmes: [],
      openDetail: false,
      titulo: "",
      Comment: "",
      IdProjects: 0,
      dialogWidth: "40%",
      modalVisible: false,
      columns: [
        {
          prop: "Name",
          label: "Nombre",
          fixed: true,
          minWidth: 500
        },
        {
          prop: "Ingresos",
          label: "Ingreso",
          minWidth: 150,
          formatter: HyperLinkReportProyects,
          attrs: {
            openDrawer: this.OpenDitails
          }
        },
        {
          prop: "Egresos",
          label: "Egreso",
          minWidth: 150,
          formatter: HyperLinkReportProyects,
          attrs: {
            openDrawer: this.OpenDitails
          }
        },
        {
          prop: "Margen",
          label: "Margen",
          minWidth: 150,
          formatter: HyperLinkReportProyects,
          attrs: {
            openDrawer: this.OpenDitails
          }
        },
        {
          prop: "MargenPorcentual",
          label: "Porcentaje",
          minWidth: 150
        },
        {
          prop: "IngresosEjecutado",
          label: "Ingreso Ejecutado",
          minWidth: 150,
          formatter: HyperLinkReportProyects,
          attrs: {
            openDrawer: this.OpenDitails
          }
        },
        {
          prop: "EgresosEjecutado",
          label: "Egreso Ejecutado",
          minWidth: 150,
          formatter: HyperLinkReportProyects,
          attrs: {
            openDrawer: this.OpenDitails
          }
        },
        {
          prop: "MargenEjecutado",
          label: "Margen Ejecutado",
          minWidth: 150,
          formatter: HyperLinkReportProyects,
          attrs: {
            openDrawer: this.OpenDitails
          }
        },
        {
          prop: "MargenPorcentualEjecutado",
          label: "Porcentaje Ejecutado",
          minWidth: 150
        },
        {
          prop: "Comment",
          label: "Comentarios de Proyectos",
          minWidth: 200
        }
      ],
      columnsdetailsegreso: [
        {
          prop: "ProveedorCode",
          label: "Codigo Proveedor",
          minWidth: 500
        },
        {
          prop: "Name",
          label: "Nombre",
          minWidth: 500
        },
        {
          prop: "Description",
          label: "Descripcion",
          minWidth: 500
        },
        {
          prop: "Motive",
          label: "Motivo",
          minWidth: 500
        },
        {
          prop: "Amount",
          label: "Monto",
          minWidth: 500
        }
      ],
      columnsdetailsingreso: [
        {
          prop: "Description",
          label: "Descripcion",
          minWidth: 500
        },
        {
          prop: "Motive",
          label: "Motivo",
          minWidth: 500
        },
        {
          prop: "Amount",
          label: "Monto",
          minWidth: 500
        }
      ],
      actionsNew: [
        {
          icon: "el-icon-plus",
          label: "Agregar Comentario",
          command: "details"
        }
      ]
    };
  },
  created() {
    this.GetProyectsReport();
  },
  methods: {
    GetProyectsReport() {
      this.$http
        .get(
          `/api/Proyects/GetReportsProyects?CompanyCode=${this.currentCompany}`
        )
        .then((resp) => {
          this.Itmes = resp.data;
        });
    },
    GetProyectsReportDetails(id, tipo, executed) {
      this.$http
        .get(
          `/api/Proyects/GetReportsProyectsDeteils?tipo=${tipo}&excuted=${executed}&id=${id}`
        )
        .then((resp) => {
          console.log(resp.data);
          this.Itmesdetails = resp.data;
          this.openDetail = true;
        });
    },
    closeModal() {
      this.modalVisible = false;
      this.Comment = "";
    },
    CloseTransactionDetail() {
      this.openDetail = false;
    },
    submitForm() {
      this.CreateCommentProjects();
    },
    CreateCommentProjects() {
      this.$http
        .post(
          `/api/Proyects/CreateCommentProjects?Idproject=${this.IdProjects}&Comment=${this.Comment}`
        )
        .then((resp) => {
          if (resp.data == 1) {
            this.closeModal();
            this.GetProyectsReport();

            this.$message({
              type: "success",
              message: "Comentario agregado exitosamente!"
            });
          } else {
            this.$message({
              type: "error",
              message: "Ocurrio un Error!"
            });
          }
        });
    },
    OpenDitails(row, column) {
      let tipo = 0;
      let execute = 0;
      switch (column) {
        case "Ingresos":
          tipo = 1;
          execute = 0;
          this.columnsdetails = this.columnsdetailsingreso;
          this.titulo = "Detalle de Ingresos";
          break;
        case "Egresos":
          tipo = 0;
          execute = 0;
          this.columnsdetails = this.columnsdetailsegreso;

          this.titulo = "Detalle de Egresos";

          break;
        case "Margen":
          tipo = 2;
          execute = 0;
          this.titulo = "Detalle de Margen";
          this.columnsdetails = this.columnsdetailsegreso;

          break;
        case "IngresosEjecutado":
          tipo = 1;
          execute = 1;
          this.columnsdetails = this.columnsdetailsingreso;
          this.titulo = "Detalle de Ingresos Ejecutado";

          break;
        case "EgresosEjecutado":
          tipo = 0;
          execute = 1;
          this.columnsdetails = this.columnsdetailsegreso;
          this.titulo = "Detalle de Egresos Ejecutado";

          break;
        case "MargenEjecutado":
          tipo = 2;
          execute = 1;
          this.titulo = "Detalle de Margen Ejecutado";

          break;
        default:
          break;
      }

      this.GetProyectsReportDetails(row.Id, tipo, execute);
    },
    handlePushAction(option) {
      this.IdProjects = option.row.Id;
      this.modalVisible = true;
    }
  }
};
</script>
